// import Vue from 'vue'
import axios from "axios";
import { Toast } from "vant";

import Router from "@/router";
import store from "@/store";

// 新加密解密方法
import Qs from "qs";
import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

// axios.pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
let pending = [];
// 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken;
let removePending = config => {
  for (let p in pending) {
    if (pending[p].u === config.url + "?" + convert(config.data)) {
      // 当当前请求在数组中存在时执行函数体
      // pending[p].f('关闭接口'); //执行取消操作
      pending.splice(p, 1); // 把这条记录从数组中移除
    }
  }
};

function convert(data) {
  // 把data转成指定的字符串
  let val = "";
  for (let i in data) {
    val = i + "=" + data[i] + "&";
  }
  return val.replace(/&$/, "");
}

// axios的一些配置，比如发送请求显示loading，请求回来loading消失之类的
// 配置发送请求的信息 config.data.encryption为true是加密
axios.interceptors.request.use(
  function(config) {
    if (!config.pending) {
      // pending 手动传进来的，如果传进来了就不记录。
      removePending(config);
      // 在一个ajax发送前执行一下取消操作
      config.cancelToken = new CancelToken(c => {
        // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
        pending.push({ u: config.url + "?" + convert(config.data), f: c });
      });
    }
    if (config.data) {
      config.data.entrance = config.data.entrance ? config.data.entrance : "4";
      config.data.imei = 0;
      config.data.model = 0;
      config.data.version = "2.2";
      config.data.language = store.getters.language == "en" ? "en-us" : "zh-cn";
      config.data.token = store.getters.token;
      config.data.encryption = 1;
      console.log("config===", config.data);
      if (config.data.encryption == 1) {
        delete config.data.encryption;
      } else {
        // 新加密
        config.key = randomStr("key");
        config.iv = randomStr("iv");
        let newConfig = {};
        newConfig.data = Encrypt(
          JSON.stringify(config.data),
          config.key,
          config.iv
        );
        newConfig.key = RsaEncrypt(config.key);
        newConfig.iv = RsaEncrypt(config.iv);
        // let configData = {}
        // configData.data = JSON.stringify(newConfig)
        config.data = Qs.stringify(newConfig);

        // 老加密
        // config.data = encryption(JSON.stringify(config.data))
      }
    }
    return config;
  },
  function(error) {
    console.log("传输错误信息", error);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    // 配置请求回来的信息
    removePending(response.config);
    // 在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
    if (response.data.type == 1) {
      // 新解密
      var key = response.config.key;
      var iv = response.config.iv;
      response.data.data = JSON.parse(Decrypt(response.data.data, key, iv));
    }
    return response.data;
  },
  function(error) {
    console.log("接口错误信息", error);
    return Promise.reject(error);
  }
);

let loadingNum = 0;
export function post(url = "", data = {}, param) {
  let loading = (param && param.loading) || false;
  let alert = (param && param.alert) || false;

  if (loading) {
    loadingNum++;
    store.dispatch("LOADING_SHOW", true);
  }
  return new Promise(resolve => {
    axios
      .post(url, data)
      .then(res => {
        if (loading) {
          if (loadingNum > 0) {
            loadingNum--;
          }
          if (loadingNum == 0) {
            store.dispatch("LOADING_SHOW", false);
          }
        }
        if (res.code == 40005) {
          debugger
          // localStorage.clear();//清空所有
          localStorage.setItem("token", "");
          store.dispatch("GET_USER_INFO", { obj: "delete" });
          store.dispatch("SET_TOKEN", "");
          if (Router.history.current.meta.power) {
            Router.push({ path: "/logReg" });
          }
          return false;
        }
        if (res.code == 10000) {
          // 维护状态！
          Router.push({ path: "/maintain" });
        }

        if (alert) {
          resolve(res);
          return false;
        }

        if (res.code == 0) {
          resolve(res.data);
        } else {
          Toast(res.msg);
        }
      })
      .catch(error => {
        if (loading) {
          if (loadingNum > 0) {
            loadingNum--;
          }
          if (loadingNum == 0) {
            store.dispatch("LOADING_SHOW", false);
          }
        }
        // 错误信息
        console.log(error, "接口錯誤信息");
      });
  });
}

// 新加密解密
function Encrypt(word, keyStr, ivStr) {
  // 加密
  let key = CryptoJS.enc.Utf8.parse(keyStr);
  let iv = CryptoJS.enc.Utf8.parse(ivStr);
  let srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

function Decrypt(word, keyStr, ivStr) {
  // 解密
  let key = CryptoJS.enc.Utf8.parse(keyStr);
  let iv = CryptoJS.enc.Utf8.parse(ivStr);
  let base64 = CryptoJS.enc.Base64.parse(word);
  let srcs = CryptoJS.enc.Base64.stringify(base64);
  var decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

function RsaEncrypt(data) {
  // Rsa加密
  // console.log('Rsa加密前数据:', data);
  var PUBLIC_KEY =
    "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC+r5K03C0cQ9FGXIxnRlnJs3F24Z0WvTil1lPJoYLzR9TH88wek4XKYpAQuQMPHpbQb7zZM2mGNUUG36onO8AaFdKPXE5um2da2EmJpX6llY47B5Na5318jPyFDf+aFkrYTn094EtUB7U6DJgfUJKue3wpvyqhHsANcxXOst/IGwIDAQAB";
  var encrypt = new JSEncrypt();
  encrypt.setPublicKey(
    "-----BEGIN PUBLIC KEY-----" + PUBLIC_KEY + "-----END PUBLIC KEY-----"
  );
  var encrypted = encrypt.encrypt(data);
  // console.log('Rsa加密后数据:', encrypted);
  return encrypted;
}

function randomStr(flag, len) {
  // 随机字符串
  len = len || 16;
  var $chars =
    "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var maxPos = $chars.length;
  var str = "";
  for (var i = 0; i < len; i++) {
    str += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  // console.log('随机字符串:' + flag, str);
  return str;
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, { params: params }).then(
      response => {
        resolve(response);
      },
      err => {
        reject(err);
      }
    );
  });
}

// 老加密解密
// function decryption(str) {
//   // 解密
//   var base64_decode = function(input) {
//     var rv;
//     rv = window.atob(input);
//     rv = escape(rv);
//     rv = decodeURIComponent(rv);
//     return rv;
//   }
//   // var token = 'hcht_2017_aapay';
//   // var token = hex_md5(token);
//   var token = "ffcc08c7a1f8f6132c1894294bb6f61c";

//   var str1 = JSON.parse(base64_decode(str));

//   var str2 = new Array();
//   var index = '';
//   for (var i = 0; i < str1.length; i++) {
//     if (i > token.length - 1) {
//       index = token.length - 1;
//     } else {
//       index = i;
//     }
//     str2[i] = String.fromCharCode(str1[i] - token[index].charCodeAt());
//   }
//   return base64_decode(str2.join(""));
// }

// function encryption(str) {
//   // 加密
//   var base64_encode = function(input) {
//     var rv;
//     rv = encodeURIComponent(input);
//     rv = unescape(rv);
//     rv = window.btoa(rv);
//     return rv;
//   }
//   // var token = hex_md5('hcht_2017_aapay');
//   var token ="ffcc08c7a1f8f6132c1894294bb6f61c";
//   var str1 = base64_encode(str);

//   var len = str1.length;

//   var data = new Array();
//   var index = 0;
//   for (var i = 0; i < len; i++) {
//     if (i > token.length - 1) {
//       index = token.length - 1;
//     } else {
//       index = i;
//     }
//     data[i] = str1[i].charCodeAt() + token[index].charCodeAt();
//   }
//   data = base64_encode('['+data.join(",")+']');

//   var str2 = {
//     data: data
//   }
//   return str2;
// }
